import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";
import {useNavigate} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {BiSolidSelectMultiple} from "react-icons/bi";
import {LiaUserEditSolid} from "react-icons/lia";
import DatePicker, {DateObject} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import "../../Assets/Styles/wallet.scss";

const toGregorianString = (dateObj) =>
    new DateObject(dateObj).convert(gregorian, gregorian_en).format("YYYY-MM-DD");

const QUICK_RANGES = [
    {key: 'all', label: 'همه', days: null},
    {key: '7', label: '۷ روز اخیر', days: 7},
    {key: '30', label: '۳۰ روز اخیر', days: 30},
    {key: '90', label: '۳ ماه اخیر', days: 90},
];

function Wallet() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [walletLoading, setWalletLoading] = React.useState(true);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState(0);
    const [wallet, setWallet] = React.useState({});
    const [range, setRange] = React.useState([]);
    const [quick, setQuick] = React.useState('all');
    const requestIdRef = React.useRef(0);

    const showError = (error) => {
        if (error.response) {
            toast.error(error.response.data.message);
        } else {
            toast.error(error.message);
        }
    };

    const fetchWallet = React.useCallback((from, to) => {
        const myId = ++requestIdRef.current;
        setWalletLoading(true);

        const params = {orderBy: 'id', orderType: 'desc'};
        if (from) params.from = from;
        if (to) params.to = to;

        API.getWalletDetail(params)
            .then((response) => {
                if (myId !== requestIdRef.current) return;
                setWallet(response.data);
                setWalletLoading(false);
            })
            .catch((error) => {
                if (myId !== requestIdRef.current) return;
                setWalletLoading(false);
                showError(error);
            });
    }, []);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login');
        }

        // بررسی کنید: پارامترهای زیر را با کد قبلی خودتان یکی کنید
        const params = {
            processForSuppliers: 1,
            vendor_id: window.localStorage.getItem("vendor"),
            orderBy: 'id',
            orderType: 'desc',
        };

        API.getVendor(params)
            .catch((error) => {
                setTimeout(() => navigate(`/vendor/select`), 400);
                showError(error);
            });

        API.getUserInfo()
            .then((response) => {
                setIsLoaded(true);
                setUser(response.data.user);

                const vendors = response.data.user.vendor || [];
                for (let v in vendors) {
                    if (vendors[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(vendors[v].ordersCount);
                    }
                }

                if (vendors.length && !window.localStorage.getItem("vendor")) {
                    window.localStorage.setItem("vendorTitle", vendors[0].title);
                    window.localStorage.setItem("vendor", vendors[0].id);
                }
            })
            .catch((error) => {
                setIsLoaded(true);
                showError(error);
            });

        fetchWallet();
        // eslint-disable-next-line
    }, []);

    const onRangeChange = (value) => {
        setRange(value);
        setQuick(null);
        if (value && value.length === 2) {
            fetchWallet(toGregorianString(value[0]), toGregorianString(value[1]));
        }
    };

    const onQuickClick = (item) => {
        setQuick(item.key);

        if (item.days === null) {
            setRange([]);
            fetchWallet();
            return;
        }

        const end = new DateObject({calendar: persian, locale: persian_fa});
        const start = new DateObject({calendar: persian, locale: persian_fa})
            .subtract(item.days - 1, 'days');

        setRange([start, end]);
        fetchWallet(toGregorianString(start), toGregorianString(end));
    };

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/");
    };

    const closeMenuOnMobile = () => {
        if (window.screen.width < 500) {
            window.document.getElementById('side-menu').style.display = 'none';
        }
    };

    const balance = Number(wallet.balance) || 0;
    const hasRange = range && range.length === 2;
    const rangeText = hasRange
        ? `از ${range[0].format("YYYY/MM/DD")} تا ${range[1].format("YYYY/MM/DD")}`
        : 'همه تراکنش‌ها';

    return (
        <React.Fragment>
            <Toast/>
            {!isLoaded && <Loading/>}

            <section className="container-fluid rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end"
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>
                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded" width='30'/>
                    </div>
                </div>

                <div className="row main-box">
                    <div className="col-md-3 p-5 d-none-print">
                        <div className="row" id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center pt-3">
                                        {
                                            isLoaded && user?.vendor?.map(vendor => {
                                                if (vendor.id === parseInt(window.localStorage.getItem("vendor"))) {
                                                    return (
                                                        <img key={vendor.id} src={vendor.cover_photo} alt="Cover"
                                                             className='w-100 mt-3 company-cover-photo'/>
                                                    );
                                                }
                                                return null;
                                            })
                                        }
                                        <div className='text-primary-color my-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;
                                            {user.surname}
                                            &nbsp;
                                            ({window.localStorage.getItem("vendorTitle")})
                                        </div>
                                    </div>

                                    <div className="col-12 item" onClick={() => navigate(`/home`)}>
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&
                                            <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3'>
                                                {orderCount}
                                            </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={() => navigate(`/home/1`)}>
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={() => navigate(`/home/2`)}>
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={() => navigate(`/products`)}>
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={() => navigate(`/vendor/manage`)}>
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={() => navigate(`/vendor/select`)}>
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={() => navigate(`/edit-profile`)}>
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={() => navigate(`/reports`)}>
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={() => navigate(`/product-reports`)}>
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فروش کالا
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={closeMenuOnMobile} id='active'>
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش صورت عملکرد
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item" onClick={onExitClick}>
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-9 pt-md-5 main-part mt-md-5 w-100-print">
                        <div className="row pb-5 px-2">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                                {window.localStorage.getItem("vendorTitle")}
                                <div>
                                    <button className="d-none-print btn btn-outline-secondary mt-3 text-small-2 px-3"
                                            onClick={() => window.print()}>
                                        چاپ
                                    </button>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="wallet-page" dir="rtl">

                                    <div className="wallet-filter card border-0 shadow-sm mb-3 d-none-print">
                                        <div className="card-body">
                                            <div className="wallet-filter__title">بازه زمانی</div>

                                            <div className="wallet-filter__quick">
                                                {QUICK_RANGES.map((item) => (
                                                    <button
                                                        key={item.key}
                                                        type="button"
                                                        className={`wallet-chip ${quick === item.key ? 'is-active' : ''}`}
                                                        onClick={() => onQuickClick(item)}
                                                    >
                                                        {item.label}
                                                    </button>
                                                ))}
                                            </div>

                                            <div className="wallet-filter__picker">
                                                <DatePicker
                                                    range
                                                    rangeHover
                                                    value={range}
                                                    onChange={onRangeChange}
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                    calendarPosition="bottom-right"
                                                    format="YYYY/MM/DD"
                                                    maxDate={new Date()}
                                                    editable={false}
                                                    placeholder="انتخاب بازه تاریخی (از تاریخ - تا تاریخ)"
                                                    inputClass="form-control text-center"
                                                    containerClassName="w-100"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="wallet-range-label mb-2">
                                        <span>{rangeText}</span>
                                        {walletLoading && <span className="wallet-range-label__loading">در حال بارگذاری...</span>}
                                    </div>

                                    <div className={walletLoading ? 'wallet-content is-loading' : 'wallet-content'}>
                                        <div className="wallet-balance card border-0 shadow-sm text-center mb-3">
                                            <div className="card-body py-4">
                                                <div className="wallet-balance__label">
                                                    {hasRange ? 'موجودی در بازه انتخابی' : 'موجودی'}
                                                </div>
                                                <div className={`wallet-balance__value ${balance < 0 ? 'is-neg' : 'is-pos'}`}>
                                                    {balance.toLocaleString("fa-IR")}
                                                    <small className="ms-2">ریال</small>
                                                </div>
                                                {hasRange && wallet.total_balance !== undefined && (
                                                    <div className="wallet-balance__total">
                                                        موجودی کل کیف پول:&nbsp;
                                                        {(Number(wallet.total_balance) || 0).toLocaleString("fa-IR")}
                                                        &nbsp;ریال
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row g-3 mb-4">
                                            <div className="col-6">
                                                <div className="wallet-total wallet-total--debit shadow-sm">
                                                    <span>جمع بدهکاری</span>
                                                    <strong>{(Number(wallet.decrease) || 0).toLocaleString("fa-IR")}</strong>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="wallet-total wallet-total--credit shadow-sm">
                                                    <span>جمع بستانکاری</span>
                                                    <strong>{(Number(wallet.increase) || 0).toLocaleString("fa-IR")}</strong>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card border-0 shadow-sm wallet-table-card">
                                            <div className="table-responsive">
                                                <table className="table table-borderless align-middle mb-0 wallet-table">
                                                    <thead>
                                                    <tr>
                                                        <th>تاریخ</th>
                                                        <th>شرح عملکرد</th>
                                                        <th className="text-end">بدهکار</th>
                                                        <th className="text-end">بستانکار</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {wallet.transactions?.length ? (
                                                        wallet.transactions.map((t) => {
                                                            const debit = Number(t.decrease_amount) || 0;
                                                            const credit = Number(t.increase_amount) || 0;
                                                            return (
                                                                <tr key={t.id} className={credit > 0 ? 'row-credit' : 'row-debit'}>
                                                                    <td className="wallet-date">{t.date?.trim()}</td>
                                                                    <td>
                                                                        <div className="wallet-title">{t.title}</div>
                                                                        <div className="wallet-desc">{t.description}</div>
                                                                    </td>
                                                                    <td className="text-end wallet-amount text-debit">
                                                                        {debit > 0 ? debit.toLocaleString("fa-IR") : "—"}
                                                                    </td>
                                                                    <td className="text-end wallet-amount text-credit">
                                                                        {credit > 0 ? credit.toLocaleString("fa-IR") : "—"}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={4} className="text-center text-muted py-4">
                                                                {walletLoading ? 'در حال بارگذاری...' : 'تراکنشی در این بازه ثبت نشده است'}
                                                            </td>
                                                        </tr>
                                                    )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {wallet.truncated && (
                                            <div className="wallet-note mt-3">
                                                تعداد تراکنش‌های این بازه ({Number(wallet.count).toLocaleString("fa-IR")} مورد)
                                                بیشتر از حد نمایش است. مجموع‌ها شامل همه تراکنش‌هاست، ولی جدول فقط
                                                جدیدترین موارد را نشان می‌دهد. برای دیدن بقیه، بازه را کوتاه‌تر کنید.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default Wallet;